import { Token } from '@/domain/types/Token'
import { Dialog, DialogContent, DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { CommonDialogProps, DialogConfig } from '../common/types'
import { RepayDialogContentContainer } from './RepayDialogContentContainer'
import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { TabSelector } from '@/ui/atoms/tab-selector/TabSelector'
import { SwapView } from './views/SwapView'
import { useEffect, useState } from 'react'
import { track } from '@/features/analytics'

export interface RepayDialogProps extends CommonDialogProps {
  token: Token
}

enum RepayDialogTabs {
  Repay = 'Repay',
  Swap = 'Swap',
}

function RepayDialog({ token, open, setOpen }: RepayDialogProps) {
  const isWrongNetwork = useWrongNetwork()
  const [activeTab, setActiveTab] = useState<RepayDialogTabs>(RepayDialogTabs.Repay)

  useEffect(() => {
    track('lend_borrow_asset_selected', {
      token: token.symbol,
      market: token.address,
      market_type: 'standard',
      action_type: 'repay',
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <DialogTitle>{`Repay ${token.symbol}`}</DialogTitle>

        <TabSelector
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={Object.values(RepayDialogTabs)}
          className="mt-2 mb-6 pb-2"
        />

        {activeTab === RepayDialogTabs.Repay && (
          <RepayDialogContentContainer token={token} closeDialog={() => setOpen(false)} />
        )}

        {activeTab === RepayDialogTabs.Swap && <SwapView token={token} />}
      </DialogContent>
    </Dialog>
  )
}

export const repayDialogConfig: DialogConfig<RepayDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: RepayDialog,
}
